export default "/images/nextempleamar-logo-2.png?0b10cc71d13f259967dd0e212dcf9ff9";